import { useSelector as useReduxSelector } from "react-redux";

import AddAmenities from "@components/Booking/AddAmenities/AddAmenities";
import AddGuests from "@components/Booking/AddGuest/AddGuest";
import Pricing from "@components/Booking/BookingForm/Pricing/Pricing";
import { useLocationContext } from "@contexts/location/LocationContext";
import { AmenityAPIResponse } from "@models/services/amenity";
import {
  BookingFetchResponseType,
  SelectedAmenity,
} from "@models/services/booking";
import { RootState } from "@store/index";

const BookingDrawerStepTwo = ({
  allowBringGuest,
  amenitiesList,
  bookingSlots,
  grandTotal,
  guestError,
  onGrandTotalChange,
  payment,
  selectedAmenitie,
  setAmenitiesList,
  setSelectedAmenities,
}: {
  payment: {
    selectedPaymentMethod: string;
    setSelectedPaymentMethod: (paymentMethod: string) => void;
  };
  bookingSlots: BookingFetchResponseType;
  grandTotal?: number;
  guestError: string;
  allowBringGuest: boolean;
  selectedAmenitie: SelectedAmenity[];
  setSelectedAmenities: (amenities: SelectedAmenity[]) => void;
  amenitiesList: AmenityAPIResponse[];
  setAmenitiesList: (amenities: AmenityAPIResponse[]) => void;
  onGrandTotalChange?: (grandTotal: number) => void;
}) => {
  const { activeLocation } = useLocationContext();
  const locationId = activeLocation?.id;

  const { guestList, selectedDate, selectedSlot, selectedTime } =
    useReduxSelector((State: RootState) => State.booking);

  return (
    <>
      {selectedTime !== "" &&
        Object.keys(selectedSlot || {}).length > 0 &&
        selectedSlot?.isBookable &&
        !(!allowBringGuest && guestList.length === 0) && (
          <AddGuests slotInfo={bookingSlots} guestError={guestError} />
        )}
      {selectedTime !== "" &&
        Object.keys(selectedSlot || {}).length > 0 &&
        selectedSlot?.isBookable && (
          <AddAmenities
            slots={bookingSlots}
            selectedDate={selectedDate}
            selectedTime={selectedTime}
            selectedSlot={selectedSlot}
            locationId={locationId}
            selectedAmenitie={selectedAmenitie}
            setSelectedAmenities={setSelectedAmenities}
            amenitiesList={amenitiesList}
            setAmenitiesList={setAmenitiesList}
          />
        )}

      <Pricing
        payment={{
          selectedPaymentMethod: payment.selectedPaymentMethod,
          setSelectedPaymentMethod: payment.setSelectedPaymentMethod,
        }}
        isFromDrawer={true}
        selectedAmenitie={selectedAmenitie}
        amenitiesList={amenitiesList}
        grandTotal={grandTotal}
        onGrandTotalChange={onGrandTotalChange}
      />
    </>
  );
};

export default BookingDrawerStepTwo;
